<!-- Main view/routes wrapper-->
<p-toast>
  <ng-template let-message pTemplate="message">
    <span class="p-toast-message-icon pi" [ngClass]="message.icon"></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary" [innerHTML]="message.summary"></div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>
<span defaultOverlayTarget></span>
<wait-component></wait-component>
<router-outlet></router-outlet>
<div class="visible-lg" id="checkLg" #checkLg></div>
<div class="visible-md" id="checkMd" #checkMd></div>
<div class="visible-sm" id="checkSm" #checkSm></div>